function qo(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function zo(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var Vo = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var a = 42;
  e[r] = a;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var o = Object.getOwnPropertySymbols(e);
  if (o.length !== 1 || o[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var f = Object.getOwnPropertyDescriptor(e, r);
    if (f.value !== a || f.enumerable !== !0)
      return !1;
  }
  return !0;
}, Ir = typeof Symbol < "u" && Symbol, Jo = Vo, Qo = function() {
  return typeof Ir != "function" || typeof Symbol != "function" || typeof Ir("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Jo();
}, _r = {
  foo: {}
}, Ko = Object, Zo = function() {
  return { __proto__: _r }.foo === _r.foo && !({ __proto__: null } instanceof Ko);
}, Xo = "Function.prototype.bind called on incompatible ", ht = Array.prototype.slice, Yo = Object.prototype.toString, ea = "[object Function]", ta = function(e) {
  var r = this;
  if (typeof r != "function" || Yo.call(r) !== ea)
    throw new TypeError(Xo + r);
  for (var n = ht.call(arguments, 1), a, o = function() {
    if (this instanceof a) {
      var d = r.apply(
        this,
        n.concat(ht.call(arguments))
      );
      return Object(d) === d ? d : this;
    } else
      return r.apply(
        e,
        n.concat(ht.call(arguments))
      );
  }, f = Math.max(0, r.length - n.length), i = [], l = 0; l < f; l++)
    i.push("$" + l);
  if (a = Function("binder", "return function (" + i.join(",") + "){ return binder.apply(this,arguments); }")(o), r.prototype) {
    var p = function() {
    };
    p.prototype = r.prototype, a.prototype = new p(), p.prototype = null;
  }
  return a;
}, ra = ta, ur = Function.prototype.bind || ra, na = ur, oa = na.call(Function.call, Object.prototype.hasOwnProperty), F, Ce = SyntaxError, lo = Function, $e = TypeError, bt = function(t) {
  try {
    return lo('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, Ee = Object.getOwnPropertyDescriptor;
if (Ee)
  try {
    Ee({}, "");
  } catch {
    Ee = null;
  }
var St = function() {
  throw new $e();
}, aa = Ee ? function() {
  try {
    return arguments.callee, St;
  } catch {
    try {
      return Ee(arguments, "callee").get;
    } catch {
      return St;
    }
  }
}() : St, Te = Qo(), ia = Zo(), H = Object.getPrototypeOf || (ia ? function(t) {
  return t.__proto__;
} : null), Me = {}, ua = typeof Uint8Array > "u" || !H ? F : H(Uint8Array), Pe = {
  "%AggregateError%": typeof AggregateError > "u" ? F : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? F : ArrayBuffer,
  "%ArrayIteratorPrototype%": Te && H ? H([][Symbol.iterator]()) : F,
  "%AsyncFromSyncIteratorPrototype%": F,
  "%AsyncFunction%": Me,
  "%AsyncGenerator%": Me,
  "%AsyncGeneratorFunction%": Me,
  "%AsyncIteratorPrototype%": Me,
  "%Atomics%": typeof Atomics > "u" ? F : Atomics,
  "%BigInt%": typeof BigInt > "u" ? F : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? F : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? F : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? F : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? F : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? F : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? F : FinalizationRegistry,
  "%Function%": lo,
  "%GeneratorFunction%": Me,
  "%Int8Array%": typeof Int8Array > "u" ? F : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? F : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? F : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": Te && H ? H(H([][Symbol.iterator]())) : F,
  "%JSON%": typeof JSON == "object" ? JSON : F,
  "%Map%": typeof Map > "u" ? F : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !Te || !H ? F : H((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? F : Promise,
  "%Proxy%": typeof Proxy > "u" ? F : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? F : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? F : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !Te || !H ? F : H((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? F : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": Te && H ? H(""[Symbol.iterator]()) : F,
  "%Symbol%": Te ? Symbol : F,
  "%SyntaxError%": Ce,
  "%ThrowTypeError%": aa,
  "%TypedArray%": ua,
  "%TypeError%": $e,
  "%Uint8Array%": typeof Uint8Array > "u" ? F : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? F : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? F : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? F : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? F : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? F : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? F : WeakSet
};
if (H)
  try {
    null.error;
  } catch (t) {
    var fa = H(H(t));
    Pe["%Error.prototype%"] = fa;
  }
var ca = function t(e) {
  var r;
  if (e === "%AsyncFunction%")
    r = bt("async function () {}");
  else if (e === "%GeneratorFunction%")
    r = bt("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    r = bt("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var n = t("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var a = t("%AsyncGenerator%");
    a && H && (r = H(a.prototype));
  }
  return Pe[e] = r, r;
}, Nr = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Je = ur, rt = oa, la = Je.call(Function.call, Array.prototype.concat), pa = Je.call(Function.apply, Array.prototype.splice), Tr = Je.call(Function.call, String.prototype.replace), nt = Je.call(Function.call, String.prototype.slice), ya = Je.call(Function.call, RegExp.prototype.exec), sa = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, da = /\\(\\)?/g, va = function(e) {
  var r = nt(e, 0, 1), n = nt(e, -1);
  if (r === "%" && n !== "%")
    throw new Ce("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new Ce("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return Tr(e, sa, function(o, f, i, l) {
    a[a.length] = i ? Tr(l, da, "$1") : f || o;
  }), a;
}, ga = function(e, r) {
  var n = e, a;
  if (rt(Nr, n) && (a = Nr[n], n = "%" + a[0] + "%"), rt(Pe, n)) {
    var o = Pe[n];
    if (o === Me && (o = ca(n)), typeof o > "u" && !r)
      throw new $e("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: n,
      value: o
    };
  }
  throw new Ce("intrinsic " + e + " does not exist!");
}, fr = function(e, r) {
  if (typeof e != "string" || e.length === 0)
    throw new $e("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new $e('"allowMissing" argument must be a boolean');
  if (ya(/^%?[^%]*%?$/, e) === null)
    throw new Ce("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = va(e), a = n.length > 0 ? n[0] : "", o = ga("%" + a + "%", r), f = o.name, i = o.value, l = !1, p = o.alias;
  p && (a = p[0], pa(n, la([0, 1], p)));
  for (var d = 1, b = !0; d < n.length; d += 1) {
    var c = n[d], h = nt(c, 0, 1), A = nt(c, -1);
    if ((h === '"' || h === "'" || h === "`" || A === '"' || A === "'" || A === "`") && h !== A)
      throw new Ce("property names with quotes must have matching quotes");
    if ((c === "constructor" || !b) && (l = !0), a += "." + c, f = "%" + a + "%", rt(Pe, f))
      i = Pe[f];
    else if (i != null) {
      if (!(c in i)) {
        if (!r)
          throw new $e("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (Ee && d + 1 >= n.length) {
        var y = Ee(i, c);
        b = !!y, b && "get" in y && !("originalValue" in y.get) ? i = y.get : i = i[c];
      } else
        b = rt(i, c), i = i[c];
      b && !l && (Pe[f] = i);
    }
  }
  return i;
}, po = { exports: {} };
(function(t) {
  var e = ur, r = fr, n = r("%Function.prototype.apply%"), a = r("%Function.prototype.call%"), o = r("%Reflect.apply%", !0) || e.call(a, n), f = r("%Object.getOwnPropertyDescriptor%", !0), i = r("%Object.defineProperty%", !0), l = r("%Math.max%");
  if (i)
    try {
      i({}, "a", { value: 1 });
    } catch {
      i = null;
    }
  t.exports = function(b) {
    var c = o(e, a, arguments);
    if (f && i) {
      var h = f(c, "length");
      h.configurable && i(
        c,
        "length",
        { value: 1 + l(0, b.length - (arguments.length - 1)) }
      );
    }
    return c;
  };
  var p = function() {
    return o(e, n, arguments);
  };
  i ? i(t.exports, "apply", { value: p }) : t.exports.apply = p;
})(po);
var ma = po.exports, yo = fr, so = ma, ha = so(yo("String.prototype.indexOf")), ba = function(e, r) {
  var n = yo(e, !!r);
  return typeof n == "function" && ha(e, ".prototype.") > -1 ? so(n) : n;
};
const Sa = {}, Aa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sa
}, Symbol.toStringTag, { value: "Module" })), Oa = /* @__PURE__ */ zo(Aa);
var cr = typeof Map == "function" && Map.prototype, At = Object.getOwnPropertyDescriptor && cr ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, ot = cr && At && typeof At.get == "function" ? At.get : null, Mr = cr && Map.prototype.forEach, lr = typeof Set == "function" && Set.prototype, Ot = Object.getOwnPropertyDescriptor && lr ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, at = lr && Ot && typeof Ot.get == "function" ? Ot.get : null, kr = lr && Set.prototype.forEach, wa = typeof WeakMap == "function" && WeakMap.prototype, qe = wa ? WeakMap.prototype.has : null, Ea = typeof WeakSet == "function" && WeakSet.prototype, ze = Ea ? WeakSet.prototype.has : null, Pa = typeof WeakRef == "function" && WeakRef.prototype, $r = Pa ? WeakRef.prototype.deref : null, ja = Boolean.prototype.valueOf, Ra = Object.prototype.toString, xa = Function.prototype.toString, Fa = String.prototype.match, pr = String.prototype.slice, ge = String.prototype.replace, Ia = String.prototype.toUpperCase, Cr = String.prototype.toLowerCase, vo = RegExp.prototype.test, Dr = Array.prototype.concat, ue = Array.prototype.join, _a = Array.prototype.slice, Br = Math.floor, tr = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, wt = Object.getOwnPropertySymbols, rr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, De = typeof Symbol == "function" && typeof Symbol.iterator == "object", Q = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === De || "symbol") ? Symbol.toStringTag : null, go = Object.prototype.propertyIsEnumerable, Ur = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
  return t.__proto__;
} : null);
function Wr(t, e) {
  if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || vo.call(/e/, e))
    return e;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof t == "number") {
    var n = t < 0 ? -Br(-t) : Br(t);
    if (n !== t) {
      var a = String(n), o = pr.call(e, a.length + 1);
      return ge.call(a, r, "$&_") + "." + ge.call(ge.call(o, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return ge.call(e, r, "$&_");
}
var nr = Oa, Lr = nr.custom, Gr = ho(Lr) ? Lr : null, Na = function t(e, r, n, a) {
  var o = r || {};
  if (ve(o, "quoteStyle") && o.quoteStyle !== "single" && o.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (ve(o, "maxStringLength") && (typeof o.maxStringLength == "number" ? o.maxStringLength < 0 && o.maxStringLength !== 1 / 0 : o.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var f = ve(o, "customInspect") ? o.customInspect : !0;
  if (typeof f != "boolean" && f !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (ve(o, "indent") && o.indent !== null && o.indent !== "	" && !(parseInt(o.indent, 10) === o.indent && o.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (ve(o, "numericSeparator") && typeof o.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var i = o.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return So(e, o);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var l = String(e);
    return i ? Wr(e, l) : l;
  }
  if (typeof e == "bigint") {
    var p = String(e) + "n";
    return i ? Wr(e, p) : p;
  }
  var d = typeof o.depth > "u" ? 5 : o.depth;
  if (typeof n > "u" && (n = 0), n >= d && d > 0 && typeof e == "object")
    return or(e) ? "[Array]" : "[Object]";
  var b = Ka(o, n);
  if (typeof a > "u")
    a = [];
  else if (bo(a, e) >= 0)
    return "[Circular]";
  function c(C, k, M) {
    if (k && (a = _a.call(a), a.push(k)), M) {
      var x = {
        depth: o.depth
      };
      return ve(o, "quoteStyle") && (x.quoteStyle = o.quoteStyle), t(C, x, n + 1, a);
    }
    return t(C, o, n + 1, a);
  }
  if (typeof e == "function" && !Hr(e)) {
    var h = Wa(e), A = Xe(e, c);
    return "[Function" + (h ? ": " + h : " (anonymous)") + "]" + (A.length > 0 ? " { " + ue.call(A, ", ") + " }" : "");
  }
  if (ho(e)) {
    var y = De ? ge.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : rr.call(e);
    return typeof e == "object" && !De ? He(y) : y;
  }
  if (Va(e)) {
    for (var v = "<" + Cr.call(String(e.nodeName)), g = e.attributes || [], m = 0; m < g.length; m++)
      v += " " + g[m].name + "=" + mo(Ta(g[m].value), "double", o);
    return v += ">", e.childNodes && e.childNodes.length && (v += "..."), v += "</" + Cr.call(String(e.nodeName)) + ">", v;
  }
  if (or(e)) {
    if (e.length === 0)
      return "[]";
    var S = Xe(e, c);
    return b && !Qa(S) ? "[" + ar(S, b) + "]" : "[ " + ue.call(S, ", ") + " ]";
  }
  if (ka(e)) {
    var w = Xe(e, c);
    return !("cause" in Error.prototype) && "cause" in e && !go.call(e, "cause") ? "{ [" + String(e) + "] " + ue.call(Dr.call("[cause]: " + c(e.cause), w), ", ") + " }" : w.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + ue.call(w, ", ") + " }";
  }
  if (typeof e == "object" && f) {
    if (Gr && typeof e[Gr] == "function" && nr)
      return nr(e, { depth: d - n });
    if (f !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (La(e)) {
    var E = [];
    return Mr && Mr.call(e, function(C, k) {
      E.push(c(k, e, !0) + " => " + c(C, e));
    }), qr("Map", ot.call(e), E, b);
  }
  if (qa(e)) {
    var P = [];
    return kr && kr.call(e, function(C) {
      P.push(c(C, e));
    }), qr("Set", at.call(e), P, b);
  }
  if (Ga(e))
    return Et("WeakMap");
  if (za(e))
    return Et("WeakSet");
  if (Ha(e))
    return Et("WeakRef");
  if (Ca(e))
    return He(c(Number(e)));
  if (Ba(e))
    return He(c(tr.call(e)));
  if (Da(e))
    return He(ja.call(e));
  if ($a(e))
    return He(c(String(e)));
  if (!Ma(e) && !Hr(e)) {
    var O = Xe(e, c), j = Ur ? Ur(e) === Object.prototype : e instanceof Object || e.constructor === Object, T = e instanceof Object ? "" : "null prototype", W = !j && Q && Object(e) === e && Q in e ? pr.call(me(e), 8, -1) : T ? "Object" : "", B = j || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", I = B + (W || T ? "[" + ue.call(Dr.call([], W || [], T || []), ": ") + "] " : "");
    return O.length === 0 ? I + "{}" : b ? I + "{" + ar(O, b) + "}" : I + "{ " + ue.call(O, ", ") + " }";
  }
  return String(e);
};
function mo(t, e, r) {
  var n = (r.quoteStyle || e) === "double" ? '"' : "'";
  return n + t + n;
}
function Ta(t) {
  return ge.call(String(t), /"/g, "&quot;");
}
function or(t) {
  return me(t) === "[object Array]" && (!Q || !(typeof t == "object" && Q in t));
}
function Ma(t) {
  return me(t) === "[object Date]" && (!Q || !(typeof t == "object" && Q in t));
}
function Hr(t) {
  return me(t) === "[object RegExp]" && (!Q || !(typeof t == "object" && Q in t));
}
function ka(t) {
  return me(t) === "[object Error]" && (!Q || !(typeof t == "object" && Q in t));
}
function $a(t) {
  return me(t) === "[object String]" && (!Q || !(typeof t == "object" && Q in t));
}
function Ca(t) {
  return me(t) === "[object Number]" && (!Q || !(typeof t == "object" && Q in t));
}
function Da(t) {
  return me(t) === "[object Boolean]" && (!Q || !(typeof t == "object" && Q in t));
}
function ho(t) {
  if (De)
    return t && typeof t == "object" && t instanceof Symbol;
  if (typeof t == "symbol")
    return !0;
  if (!t || typeof t != "object" || !rr)
    return !1;
  try {
    return rr.call(t), !0;
  } catch {
  }
  return !1;
}
function Ba(t) {
  if (!t || typeof t != "object" || !tr)
    return !1;
  try {
    return tr.call(t), !0;
  } catch {
  }
  return !1;
}
var Ua = Object.prototype.hasOwnProperty || function(t) {
  return t in this;
};
function ve(t, e) {
  return Ua.call(t, e);
}
function me(t) {
  return Ra.call(t);
}
function Wa(t) {
  if (t.name)
    return t.name;
  var e = Fa.call(xa.call(t), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function bo(t, e) {
  if (t.indexOf)
    return t.indexOf(e);
  for (var r = 0, n = t.length; r < n; r++)
    if (t[r] === e)
      return r;
  return -1;
}
function La(t) {
  if (!ot || !t || typeof t != "object")
    return !1;
  try {
    ot.call(t);
    try {
      at.call(t);
    } catch {
      return !0;
    }
    return t instanceof Map;
  } catch {
  }
  return !1;
}
function Ga(t) {
  if (!qe || !t || typeof t != "object")
    return !1;
  try {
    qe.call(t, qe);
    try {
      ze.call(t, ze);
    } catch {
      return !0;
    }
    return t instanceof WeakMap;
  } catch {
  }
  return !1;
}
function Ha(t) {
  if (!$r || !t || typeof t != "object")
    return !1;
  try {
    return $r.call(t), !0;
  } catch {
  }
  return !1;
}
function qa(t) {
  if (!at || !t || typeof t != "object")
    return !1;
  try {
    at.call(t);
    try {
      ot.call(t);
    } catch {
      return !0;
    }
    return t instanceof Set;
  } catch {
  }
  return !1;
}
function za(t) {
  if (!ze || !t || typeof t != "object")
    return !1;
  try {
    ze.call(t, ze);
    try {
      qe.call(t, qe);
    } catch {
      return !0;
    }
    return t instanceof WeakSet;
  } catch {
  }
  return !1;
}
function Va(t) {
  return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
}
function So(t, e) {
  if (t.length > e.maxStringLength) {
    var r = t.length - e.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
    return So(pr.call(t, 0, e.maxStringLength), e) + n;
  }
  var a = ge.call(ge.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Ja);
  return mo(a, "single", e);
}
function Ja(t) {
  var e = t.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + Ia.call(e.toString(16));
}
function He(t) {
  return "Object(" + t + ")";
}
function Et(t) {
  return t + " { ? }";
}
function qr(t, e, r, n) {
  var a = n ? ar(r, n) : ue.call(r, ", ");
  return t + " (" + e + ") {" + a + "}";
}
function Qa(t) {
  for (var e = 0; e < t.length; e++)
    if (bo(t[e], `
`) >= 0)
      return !1;
  return !0;
}
function Ka(t, e) {
  var r;
  if (t.indent === "	")
    r = "	";
  else if (typeof t.indent == "number" && t.indent > 0)
    r = ue.call(Array(t.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: ue.call(Array(e + 1), r)
  };
}
function ar(t, e) {
  if (t.length === 0)
    return "";
  var r = `
` + e.prev + e.base;
  return r + ue.call(t, "," + r) + `
` + e.prev;
}
function Xe(t, e) {
  var r = or(t), n = [];
  if (r) {
    n.length = t.length;
    for (var a = 0; a < t.length; a++)
      n[a] = ve(t, a) ? e(t[a], t) : "";
  }
  var o = typeof wt == "function" ? wt(t) : [], f;
  if (De) {
    f = {};
    for (var i = 0; i < o.length; i++)
      f["$" + o[i]] = o[i];
  }
  for (var l in t)
    ve(t, l) && (r && String(Number(l)) === l && l < t.length || De && f["$" + l] instanceof Symbol || (vo.call(/[^\w$]/, l) ? n.push(e(l, t) + ": " + e(t[l], t)) : n.push(l + ": " + e(t[l], t))));
  if (typeof wt == "function")
    for (var p = 0; p < o.length; p++)
      go.call(t, o[p]) && n.push("[" + e(o[p]) + "]: " + e(t[o[p]], t));
  return n;
}
var yr = fr, Ue = ba, Za = Na, Xa = yr("%TypeError%"), Ye = yr("%WeakMap%", !0), et = yr("%Map%", !0), Ya = Ue("WeakMap.prototype.get", !0), ei = Ue("WeakMap.prototype.set", !0), ti = Ue("WeakMap.prototype.has", !0), ri = Ue("Map.prototype.get", !0), ni = Ue("Map.prototype.set", !0), oi = Ue("Map.prototype.has", !0), sr = function(t, e) {
  for (var r = t, n; (n = r.next) !== null; r = n)
    if (n.key === e)
      return r.next = n.next, n.next = t.next, t.next = n, n;
}, ai = function(t, e) {
  var r = sr(t, e);
  return r && r.value;
}, ii = function(t, e, r) {
  var n = sr(t, e);
  n ? n.value = r : t.next = {
    // eslint-disable-line no-param-reassign
    key: e,
    next: t.next,
    value: r
  };
}, ui = function(t, e) {
  return !!sr(t, e);
}, fi = function() {
  var e, r, n, a = {
    assert: function(o) {
      if (!a.has(o))
        throw new Xa("Side channel does not contain " + Za(o));
    },
    get: function(o) {
      if (Ye && o && (typeof o == "object" || typeof o == "function")) {
        if (e)
          return Ya(e, o);
      } else if (et) {
        if (r)
          return ri(r, o);
      } else if (n)
        return ai(n, o);
    },
    has: function(o) {
      if (Ye && o && (typeof o == "object" || typeof o == "function")) {
        if (e)
          return ti(e, o);
      } else if (et) {
        if (r)
          return oi(r, o);
      } else if (n)
        return ui(n, o);
      return !1;
    },
    set: function(o, f) {
      Ye && o && (typeof o == "object" || typeof o == "function") ? (e || (e = new Ye()), ei(e, o, f)) : et ? (r || (r = new et()), ni(r, o, f)) : (n || (n = { key: {}, next: null }), ii(n, o, f));
    }
  };
  return a;
}, ci = String.prototype.replace, li = /%20/g, Pt = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, dr = {
  default: Pt.RFC3986,
  formatters: {
    RFC1738: function(t) {
      return ci.call(t, li, "+");
    },
    RFC3986: function(t) {
      return String(t);
    }
  },
  RFC1738: Pt.RFC1738,
  RFC3986: Pt.RFC3986
}, pi = dr, jt = Object.prototype.hasOwnProperty, we = Array.isArray, ie = function() {
  for (var t = [], e = 0; e < 256; ++e)
    t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return t;
}(), yi = function(e) {
  for (; e.length > 1; ) {
    var r = e.pop(), n = r.obj[r.prop];
    if (we(n)) {
      for (var a = [], o = 0; o < n.length; ++o)
        typeof n[o] < "u" && a.push(n[o]);
      r.obj[r.prop] = a;
    }
  }
}, Ao = function(e, r) {
  for (var n = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = 0; a < e.length; ++a)
    typeof e[a] < "u" && (n[a] = e[a]);
  return n;
}, si = function t(e, r, n) {
  if (!r)
    return e;
  if (typeof r != "object") {
    if (we(e))
      e.push(r);
    else if (e && typeof e == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !jt.call(Object.prototype, r)) && (e[r] = !0);
    else
      return [e, r];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(r);
  var a = e;
  return we(e) && !we(r) && (a = Ao(e, n)), we(e) && we(r) ? (r.forEach(function(o, f) {
    if (jt.call(e, f)) {
      var i = e[f];
      i && typeof i == "object" && o && typeof o == "object" ? e[f] = t(i, o, n) : e.push(o);
    } else
      e[f] = o;
  }), e) : Object.keys(r).reduce(function(o, f) {
    var i = r[f];
    return jt.call(o, f) ? o[f] = t(o[f], i, n) : o[f] = i, o;
  }, a);
}, di = function(e, r) {
  return Object.keys(r).reduce(function(n, a) {
    return n[a] = r[a], n;
  }, e);
}, vi = function(t, e, r) {
  var n = t.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, gi = function(e, r, n, a, o) {
  if (e.length === 0)
    return e;
  var f = e;
  if (typeof e == "symbol" ? f = Symbol.prototype.toString.call(e) : typeof e != "string" && (f = String(e)), n === "iso-8859-1")
    return escape(f).replace(/%u[0-9a-f]{4}/gi, function(d) {
      return "%26%23" + parseInt(d.slice(2), 16) + "%3B";
    });
  for (var i = "", l = 0; l < f.length; ++l) {
    var p = f.charCodeAt(l);
    if (p === 45 || p === 46 || p === 95 || p === 126 || p >= 48 && p <= 57 || p >= 65 && p <= 90 || p >= 97 && p <= 122 || o === pi.RFC1738 && (p === 40 || p === 41)) {
      i += f.charAt(l);
      continue;
    }
    if (p < 128) {
      i = i + ie[p];
      continue;
    }
    if (p < 2048) {
      i = i + (ie[192 | p >> 6] + ie[128 | p & 63]);
      continue;
    }
    if (p < 55296 || p >= 57344) {
      i = i + (ie[224 | p >> 12] + ie[128 | p >> 6 & 63] + ie[128 | p & 63]);
      continue;
    }
    l += 1, p = 65536 + ((p & 1023) << 10 | f.charCodeAt(l) & 1023), i += ie[240 | p >> 18] + ie[128 | p >> 12 & 63] + ie[128 | p >> 6 & 63] + ie[128 | p & 63];
  }
  return i;
}, mi = function(e) {
  for (var r = [{ obj: { o: e }, prop: "o" }], n = [], a = 0; a < r.length; ++a)
    for (var o = r[a], f = o.obj[o.prop], i = Object.keys(f), l = 0; l < i.length; ++l) {
      var p = i[l], d = f[p];
      typeof d == "object" && d !== null && n.indexOf(d) === -1 && (r.push({ obj: f, prop: p }), n.push(d));
    }
  return yi(r), e;
}, hi = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, bi = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, Si = function(e, r) {
  return [].concat(e, r);
}, Ai = function(e, r) {
  if (we(e)) {
    for (var n = [], a = 0; a < e.length; a += 1)
      n.push(r(e[a]));
    return n;
  }
  return r(e);
}, Oo = {
  arrayToObject: Ao,
  assign: di,
  combine: Si,
  compact: mi,
  decode: vi,
  encode: gi,
  isBuffer: bi,
  isRegExp: hi,
  maybeMap: Ai,
  merge: si
}, wo = fi, tt = Oo, Ve = dr, Oi = Object.prototype.hasOwnProperty, zr = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, r) {
    return e + "[" + r + "]";
  },
  repeat: function(e) {
    return e;
  }
}, le = Array.isArray, wi = Array.prototype.push, Eo = function(t, e) {
  wi.apply(t, le(e) ? e : [e]);
}, Ei = Date.prototype.toISOString, Vr = Ve.default, J = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: tt.encode,
  encodeValuesOnly: !1,
  format: Vr,
  formatter: Ve.formatters[Vr],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return Ei.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Pi = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, Rt = {}, ji = function t(e, r, n, a, o, f, i, l, p, d, b, c, h, A, y, v) {
  for (var g = e, m = v, S = 0, w = !1; (m = m.get(Rt)) !== void 0 && !w; ) {
    var E = m.get(e);
    if (S += 1, typeof E < "u") {
      if (E === S)
        throw new RangeError("Cyclic object value");
      w = !0;
    }
    typeof m.get(Rt) > "u" && (S = 0);
  }
  if (typeof l == "function" ? g = l(r, g) : g instanceof Date ? g = b(g) : n === "comma" && le(g) && (g = tt.maybeMap(g, function(x) {
    return x instanceof Date ? b(x) : x;
  })), g === null) {
    if (o)
      return i && !A ? i(r, J.encoder, y, "key", c) : r;
    g = "";
  }
  if (Pi(g) || tt.isBuffer(g)) {
    if (i) {
      var P = A ? r : i(r, J.encoder, y, "key", c);
      return [h(P) + "=" + h(i(g, J.encoder, y, "value", c))];
    }
    return [h(r) + "=" + h(String(g))];
  }
  var O = [];
  if (typeof g > "u")
    return O;
  var j;
  if (n === "comma" && le(g))
    A && i && (g = tt.maybeMap(g, i)), j = [{ value: g.length > 0 ? g.join(",") || null : void 0 }];
  else if (le(l))
    j = l;
  else {
    var T = Object.keys(g);
    j = p ? T.sort(p) : T;
  }
  for (var W = a && le(g) && g.length === 1 ? r + "[]" : r, B = 0; B < j.length; ++B) {
    var I = j[B], C = typeof I == "object" && typeof I.value < "u" ? I.value : g[I];
    if (!(f && C === null)) {
      var k = le(g) ? typeof n == "function" ? n(W, I) : W : W + (d ? "." + I : "[" + I + "]");
      v.set(e, S);
      var M = wo();
      M.set(Rt, v), Eo(O, t(
        C,
        k,
        n,
        a,
        o,
        f,
        n === "comma" && A && le(g) ? null : i,
        l,
        p,
        d,
        b,
        c,
        h,
        A,
        y,
        M
      ));
    }
  }
  return O;
}, Ri = function(e) {
  if (!e)
    return J;
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = e.charset || J.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = Ve.default;
  if (typeof e.format < "u") {
    if (!Oi.call(Ve.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    n = e.format;
  }
  var a = Ve.formatters[n], o = J.filter;
  return (typeof e.filter == "function" || le(e.filter)) && (o = e.filter), {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : J.addQueryPrefix,
    allowDots: typeof e.allowDots > "u" ? J.allowDots : !!e.allowDots,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : J.charsetSentinel,
    delimiter: typeof e.delimiter > "u" ? J.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : J.encode,
    encoder: typeof e.encoder == "function" ? e.encoder : J.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : J.encodeValuesOnly,
    filter: o,
    format: n,
    formatter: a,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : J.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : J.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : J.strictNullHandling
  };
}, xi = function(t, e) {
  var r = t, n = Ri(e), a, o;
  typeof n.filter == "function" ? (o = n.filter, r = o("", r)) : le(n.filter) && (o = n.filter, a = o);
  var f = [];
  if (typeof r != "object" || r === null)
    return "";
  var i;
  e && e.arrayFormat in zr ? i = e.arrayFormat : e && "indices" in e ? i = e.indices ? "indices" : "repeat" : i = "indices";
  var l = zr[i];
  if (e && "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var p = l === "comma" && e && e.commaRoundTrip;
  a || (a = Object.keys(r)), n.sort && a.sort(n.sort);
  for (var d = wo(), b = 0; b < a.length; ++b) {
    var c = a[b];
    n.skipNulls && r[c] === null || Eo(f, ji(
      r[c],
      c,
      l,
      p,
      n.strictNullHandling,
      n.skipNulls,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      d
    ));
  }
  var h = f.join(n.delimiter), A = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? A += "utf8=%26%2310003%3B&" : A += "utf8=%E2%9C%93&"), h.length > 0 ? A + h : "";
}, Be = Oo, ir = Object.prototype.hasOwnProperty, Fi = Array.isArray, G = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: Be.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, Ii = function(t) {
  return t.replace(/&#(\d+);/g, function(e, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, Po = function(t, e) {
  return t && typeof t == "string" && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
}, _i = "utf8=%26%2310003%3B", Ni = "utf8=%E2%9C%93", Ti = function(e, r) {
  var n = { __proto__: null }, a = r.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, o = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, f = a.split(r.delimiter, o), i = -1, l, p = r.charset;
  if (r.charsetSentinel)
    for (l = 0; l < f.length; ++l)
      f[l].indexOf("utf8=") === 0 && (f[l] === Ni ? p = "utf-8" : f[l] === _i && (p = "iso-8859-1"), i = l, l = f.length);
  for (l = 0; l < f.length; ++l)
    if (l !== i) {
      var d = f[l], b = d.indexOf("]="), c = b === -1 ? d.indexOf("=") : b + 1, h, A;
      c === -1 ? (h = r.decoder(d, G.decoder, p, "key"), A = r.strictNullHandling ? null : "") : (h = r.decoder(d.slice(0, c), G.decoder, p, "key"), A = Be.maybeMap(
        Po(d.slice(c + 1), r),
        function(y) {
          return r.decoder(y, G.decoder, p, "value");
        }
      )), A && r.interpretNumericEntities && p === "iso-8859-1" && (A = Ii(A)), d.indexOf("[]=") > -1 && (A = Fi(A) ? [A] : A), ir.call(n, h) ? n[h] = Be.combine(n[h], A) : n[h] = A;
    }
  return n;
}, Mi = function(t, e, r, n) {
  for (var a = n ? e : Po(e, r), o = t.length - 1; o >= 0; --o) {
    var f, i = t[o];
    if (i === "[]" && r.parseArrays)
      f = [].concat(a);
    else {
      f = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var l = i.charAt(0) === "[" && i.charAt(i.length - 1) === "]" ? i.slice(1, -1) : i, p = parseInt(l, 10);
      !r.parseArrays && l === "" ? f = { 0: a } : !isNaN(p) && i !== l && String(p) === l && p >= 0 && r.parseArrays && p <= r.arrayLimit ? (f = [], f[p] = a) : l !== "__proto__" && (f[l] = a);
    }
    a = f;
  }
  return a;
}, ki = function(e, r, n, a) {
  if (e) {
    var o = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, f = /(\[[^[\]]*])/, i = /(\[[^[\]]*])/g, l = n.depth > 0 && f.exec(o), p = l ? o.slice(0, l.index) : o, d = [];
    if (p) {
      if (!n.plainObjects && ir.call(Object.prototype, p) && !n.allowPrototypes)
        return;
      d.push(p);
    }
    for (var b = 0; n.depth > 0 && (l = i.exec(o)) !== null && b < n.depth; ) {
      if (b += 1, !n.plainObjects && ir.call(Object.prototype, l[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      d.push(l[1]);
    }
    return l && d.push("[" + o.slice(l.index) + "]"), Mi(d, r, n, a);
  }
}, $i = function(e) {
  if (!e)
    return G;
  if (e.decoder !== null && e.decoder !== void 0 && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof e.charset > "u" ? G.charset : e.charset;
  return {
    allowDots: typeof e.allowDots > "u" ? G.allowDots : !!e.allowDots,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : G.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : G.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : G.arrayLimit,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : G.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : G.comma,
    decoder: typeof e.decoder == "function" ? e.decoder : G.decoder,
    delimiter: typeof e.delimiter == "string" || Be.isRegExp(e.delimiter) ? e.delimiter : G.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : G.depth,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : G.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : G.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : G.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : G.strictNullHandling
  };
}, Ci = function(t, e) {
  var r = $i(e);
  if (t === "" || t === null || typeof t > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof t == "string" ? Ti(t, r) : t, a = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, o = Object.keys(n), f = 0; f < o.length; ++f) {
    var i = o[f], l = ki(i, n[i], r, typeof t == "string");
    a = Be.merge(a, l, r);
  }
  return r.allowSparse === !0 ? a : Be.compact(a);
}, Di = xi, Bi = Ci, Ui = dr, Wi = {
  formats: Ui,
  parse: Bi,
  stringify: Di
};
const Li = /* @__PURE__ */ qo(Wi);
var Jr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Gi(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule"))
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var Qr, Kr;
function We() {
  return Kr || (Kr = 1, Qr = TypeError), Qr;
}
const Hi = {}, qi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hi
}, Symbol.toStringTag, { value: "Module" })), zi = /* @__PURE__ */ Gi(qi);
var xt, Zr;
function it() {
  if (Zr)
    return xt;
  Zr = 1;
  var t = typeof Map == "function" && Map.prototype, e = Object.getOwnPropertyDescriptor && t ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = t && e && typeof e.get == "function" ? e.get : null, n = t && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, o = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, f = a && o && typeof o.get == "function" ? o.get : null, i = a && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, p = l ? WeakMap.prototype.has : null, d = typeof WeakSet == "function" && WeakSet.prototype, b = d ? WeakSet.prototype.has : null, c = typeof WeakRef == "function" && WeakRef.prototype, h = c ? WeakRef.prototype.deref : null, A = Boolean.prototype.valueOf, y = Object.prototype.toString, v = Function.prototype.toString, g = String.prototype.match, m = String.prototype.slice, S = String.prototype.replace, w = String.prototype.toUpperCase, E = String.prototype.toLowerCase, P = RegExp.prototype.test, O = Array.prototype.concat, j = Array.prototype.join, T = Array.prototype.slice, W = Math.floor, B = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, I = Object.getOwnPropertySymbols, C = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, k = typeof Symbol == "function" && typeof Symbol.iterator == "object", M = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === k || !0) ? Symbol.toStringTag : null, x = Object.prototype.propertyIsEnumerable, ae = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(u) {
    return u.__proto__;
  } : null);
  function Z(u, s) {
    if (u === 1 / 0 || u === -1 / 0 || u !== u || u && u > -1e3 && u < 1e3 || P.call(/e/, s))
      return s;
    var N = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof u == "number") {
      var $ = u < 0 ? -W(-u) : W(u);
      if ($ !== u) {
        var D = String($), R = m.call(s, D.length + 1);
        return S.call(D, N, "$&_") + "." + S.call(S.call(R, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return S.call(s, N, "$&_");
  }
  var te = zi, he = te.custom, je = z(he) ? he : null, fe = {
    __proto__: null,
    double: '"',
    single: "'"
  }, Y = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  xt = function u(s, N, $, D) {
    var R = N || {};
    if (K(R, "quoteStyle") && !K(fe, R.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (K(R, "maxStringLength") && (typeof R.maxStringLength == "number" ? R.maxStringLength < 0 && R.maxStringLength !== 1 / 0 : R.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var se = K(R, "customInspect") ? R.customInspect : !0;
    if (typeof se != "boolean" && se !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (K(R, "indent") && R.indent !== null && R.indent !== "	" && !(parseInt(R.indent, 10) === R.indent && R.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (K(R, "numericSeparator") && typeof R.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var Oe = R.numericSeparator;
    if (typeof s > "u")
      return "undefined";
    if (s === null)
      return "null";
    if (typeof s == "boolean")
      return s ? "true" : "false";
    if (typeof s == "string")
      return Sr(s, R);
    if (typeof s == "number") {
      if (s === 0)
        return 1 / 0 / s > 0 ? "0" : "-0";
      var X = String(s);
      return Oe ? Z(s, X) : X;
    }
    if (typeof s == "bigint") {
      var de = String(s) + "n";
      return Oe ? Z(s, de) : de;
    }
    var pt = typeof R.depth > "u" ? 5 : R.depth;
    if (typeof $ > "u" && ($ = 0), $ >= pt && pt > 0 && typeof s == "object")
      return ce(s) ? "[Array]" : "[Object]";
    var _e = Lo(R, $);
    if (typeof D > "u")
      D = [];
    else if (ye(D, s) >= 0)
      return "[Circular]";
    function oe(Ne, Ze, Ho) {
      if (Ze && (D = T.call(D), D.push(Ze)), Ho) {
        var Fr = {
          depth: R.depth
        };
        return K(R, "quoteStyle") && (Fr.quoteStyle = R.quoteStyle), u(Ne, Fr, $ + 1, D);
      }
      return u(Ne, R, $ + 1, D);
    }
    if (typeof s == "function" && !Ae(s)) {
      var Or = Re(s), wr = Qe(s, oe);
      return "[Function" + (Or ? ": " + Or : " (anonymous)") + "]" + (wr.length > 0 ? " { " + j.call(wr, ", ") + " }" : "");
    }
    if (z(s)) {
      var Er = k ? S.call(String(s), /^(Symbol\(.*\))_[^)]*$/, "$1") : C.call(s);
      return typeof s == "object" && !k ? Le(Er) : Er;
    }
    if (Bo(s)) {
      for (var Ge = "<" + E.call(String(s.nodeName)), yt = s.attributes || [], Ke = 0; Ke < yt.length; Ke++)
        Ge += " " + yt[Ke].name + "=" + be(Se(yt[Ke].value), "double", R);
      return Ge += ">", s.childNodes && s.childNodes.length && (Ge += "..."), Ge += "</" + E.call(String(s.nodeName)) + ">", Ge;
    }
    if (ce(s)) {
      if (s.length === 0)
        return "[]";
      var st = Qe(s, oe);
      return _e && !Wo(st) ? "[" + lt(st, _e) + "]" : "[ " + j.call(st, ", ") + " ]";
    }
    if (U(s)) {
      var dt = Qe(s, oe);
      return !("cause" in Error.prototype) && "cause" in s && !x.call(s, "cause") ? "{ [" + String(s) + "] " + j.call(O.call("[cause]: " + oe(s.cause), dt), ", ") + " }" : dt.length === 0 ? "[" + String(s) + "]" : "{ [" + String(s) + "] " + j.call(dt, ", ") + " }";
    }
    if (typeof s == "object" && se) {
      if (je && typeof s[je] == "function" && te)
        return te(s, { depth: pt - $ });
      if (se !== "symbol" && typeof s.inspect == "function")
        return s.inspect();
    }
    if (ne(s)) {
      var Pr = [];
      return n && n.call(s, function(Ne, Ze) {
        Pr.push(oe(Ze, s, !0) + " => " + oe(Ne, s));
      }), Ar("Map", r.call(s), Pr, _e);
    }
    if (Ie(s)) {
      var jr = [];
      return i && i.call(s, function(Ne) {
        jr.push(oe(Ne, s));
      }), Ar("Set", f.call(s), jr, _e);
    }
    if (xe(s))
      return ct("WeakMap");
    if (Do(s))
      return ct("WeakSet");
    if (Fe(s))
      return ct("WeakRef");
    if (_(s))
      return Le(oe(Number(s)));
    if (pe(s))
      return Le(oe(B.call(s)));
    if (q(s))
      return Le(A.call(s));
    if (L(s))
      return Le(oe(String(s)));
    if (typeof window < "u" && s === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && s === globalThis || typeof Jr < "u" && s === Jr)
      return "{ [object globalThis] }";
    if (!re(s) && !Ae(s)) {
      var vt = Qe(s, oe), Rr = ae ? ae(s) === Object.prototype : s instanceof Object || s.constructor === Object, gt = s instanceof Object ? "" : "null prototype", xr = !Rr && M && Object(s) === s && M in s ? m.call(ee(s), 8, -1) : gt ? "Object" : "", Go = Rr || typeof s.constructor != "function" ? "" : s.constructor.name ? s.constructor.name + " " : "", mt = Go + (xr || gt ? "[" + j.call(O.call([], xr || [], gt || []), ": ") + "] " : "");
      return vt.length === 0 ? mt + "{}" : _e ? mt + "{" + lt(vt, _e) + "}" : mt + "{ " + j.call(vt, ", ") + " }";
    }
    return String(s);
  };
  function be(u, s, N) {
    var $ = N.quoteStyle || s, D = fe[$];
    return D + u + D;
  }
  function Se(u) {
    return S.call(String(u), /"/g, "&quot;");
  }
  function ce(u) {
    return ee(u) === "[object Array]" && (!M || !(typeof u == "object" && M in u));
  }
  function re(u) {
    return ee(u) === "[object Date]" && (!M || !(typeof u == "object" && M in u));
  }
  function Ae(u) {
    return ee(u) === "[object RegExp]" && (!M || !(typeof u == "object" && M in u));
  }
  function U(u) {
    return ee(u) === "[object Error]" && (!M || !(typeof u == "object" && M in u));
  }
  function L(u) {
    return ee(u) === "[object String]" && (!M || !(typeof u == "object" && M in u));
  }
  function _(u) {
    return ee(u) === "[object Number]" && (!M || !(typeof u == "object" && M in u));
  }
  function q(u) {
    return ee(u) === "[object Boolean]" && (!M || !(typeof u == "object" && M in u));
  }
  function z(u) {
    if (k)
      return u && typeof u == "object" && u instanceof Symbol;
    if (typeof u == "symbol")
      return !0;
    if (!u || typeof u != "object" || !C)
      return !1;
    try {
      return C.call(u), !0;
    } catch {
    }
    return !1;
  }
  function pe(u) {
    if (!u || typeof u != "object" || !B)
      return !1;
    try {
      return B.call(u), !0;
    } catch {
    }
    return !1;
  }
  var V = Object.prototype.hasOwnProperty || function(u) {
    return u in this;
  };
  function K(u, s) {
    return V.call(u, s);
  }
  function ee(u) {
    return y.call(u);
  }
  function Re(u) {
    if (u.name)
      return u.name;
    var s = g.call(v.call(u), /^function\s*([\w$]+)/);
    return s ? s[1] : null;
  }
  function ye(u, s) {
    if (u.indexOf)
      return u.indexOf(s);
    for (var N = 0, $ = u.length; N < $; N++)
      if (u[N] === s)
        return N;
    return -1;
  }
  function ne(u) {
    if (!r || !u || typeof u != "object")
      return !1;
    try {
      r.call(u);
      try {
        f.call(u);
      } catch {
        return !0;
      }
      return u instanceof Map;
    } catch {
    }
    return !1;
  }
  function xe(u) {
    if (!p || !u || typeof u != "object")
      return !1;
    try {
      p.call(u, p);
      try {
        b.call(u, b);
      } catch {
        return !0;
      }
      return u instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Fe(u) {
    if (!h || !u || typeof u != "object")
      return !1;
    try {
      return h.call(u), !0;
    } catch {
    }
    return !1;
  }
  function Ie(u) {
    if (!f || !u || typeof u != "object")
      return !1;
    try {
      f.call(u);
      try {
        r.call(u);
      } catch {
        return !0;
      }
      return u instanceof Set;
    } catch {
    }
    return !1;
  }
  function Do(u) {
    if (!b || !u || typeof u != "object")
      return !1;
    try {
      b.call(u, b);
      try {
        p.call(u, p);
      } catch {
        return !0;
      }
      return u instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Bo(u) {
    return !u || typeof u != "object" ? !1 : typeof HTMLElement < "u" && u instanceof HTMLElement ? !0 : typeof u.nodeName == "string" && typeof u.getAttribute == "function";
  }
  function Sr(u, s) {
    if (u.length > s.maxStringLength) {
      var N = u.length - s.maxStringLength, $ = "... " + N + " more character" + (N > 1 ? "s" : "");
      return Sr(m.call(u, 0, s.maxStringLength), s) + $;
    }
    var D = Y[s.quoteStyle || "single"];
    D.lastIndex = 0;
    var R = S.call(S.call(u, D, "\\$1"), /[\x00-\x1f]/g, Uo);
    return be(R, "single", s);
  }
  function Uo(u) {
    var s = u.charCodeAt(0), N = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[s];
    return N ? "\\" + N : "\\x" + (s < 16 ? "0" : "") + w.call(s.toString(16));
  }
  function Le(u) {
    return "Object(" + u + ")";
  }
  function ct(u) {
    return u + " { ? }";
  }
  function Ar(u, s, N, $) {
    var D = $ ? lt(N, $) : j.call(N, ", ");
    return u + " (" + s + ") {" + D + "}";
  }
  function Wo(u) {
    for (var s = 0; s < u.length; s++)
      if (ye(u[s], `
`) >= 0)
        return !1;
    return !0;
  }
  function Lo(u, s) {
    var N;
    if (u.indent === "	")
      N = "	";
    else if (typeof u.indent == "number" && u.indent > 0)
      N = j.call(Array(u.indent + 1), " ");
    else
      return null;
    return {
      base: N,
      prev: j.call(Array(s + 1), N)
    };
  }
  function lt(u, s) {
    if (u.length === 0)
      return "";
    var N = `
` + s.prev + s.base;
    return N + j.call(u, "," + N) + `
` + s.prev;
  }
  function Qe(u, s) {
    var N = ce(u), $ = [];
    if (N) {
      $.length = u.length;
      for (var D = 0; D < u.length; D++)
        $[D] = K(u, D) ? s(u[D], u) : "";
    }
    var R = typeof I == "function" ? I(u) : [], se;
    if (k) {
      se = {};
      for (var Oe = 0; Oe < R.length; Oe++)
        se["$" + R[Oe]] = R[Oe];
    }
    for (var X in u)
      K(u, X) && (N && String(Number(X)) === X && X < u.length || k && se["$" + X] instanceof Symbol || (P.call(/[^\w$]/, X) ? $.push(s(X, u) + ": " + s(u[X], u)) : $.push(X + ": " + s(u[X], u))));
    if (typeof I == "function")
      for (var de = 0; de < R.length; de++)
        x.call(u, R[de]) && $.push("[" + s(R[de]) + "]: " + s(u[R[de]], u));
    return $;
  }
  return xt;
}
var Ft, Xr;
function Vi() {
  if (Xr)
    return Ft;
  Xr = 1;
  var t = /* @__PURE__ */ it(), e = /* @__PURE__ */ We(), r = function(i, l, p) {
    for (var d = i, b; (b = d.next) != null; d = b)
      if (b.key === l)
        return d.next = b.next, p || (b.next = /** @type {NonNullable<typeof list.next>} */
        i.next, i.next = b), b;
  }, n = function(i, l) {
    if (i) {
      var p = r(i, l);
      return p && p.value;
    }
  }, a = function(i, l, p) {
    var d = r(i, l);
    d ? d.value = p : i.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: l,
      next: i.next,
      value: p
    };
  }, o = function(i, l) {
    return i ? !!r(i, l) : !1;
  }, f = function(i, l) {
    if (i)
      return r(i, l, !0);
  };
  return Ft = function() {
    var i, l = {
      assert: function(p) {
        if (!l.has(p))
          throw new e("Side channel does not contain " + t(p));
      },
      delete: function(p) {
        var d = i && i.next, b = f(i, p);
        return b && d && d === b && (i = void 0), !!b;
      },
      get: function(p) {
        return n(i, p);
      },
      has: function(p) {
        return o(i, p);
      },
      set: function(p, d) {
        i || (i = {
          next: void 0
        }), a(
          /** @type {NonNullable<typeof $o>} */
          i,
          p,
          d
        );
      }
    };
    return l;
  }, Ft;
}
var Yr, en;
function jo() {
  return en || (en = 1, Yr = Object), Yr;
}
var tn, rn;
function Ji() {
  return rn || (rn = 1, tn = Error), tn;
}
var nn, on;
function Qi() {
  return on || (on = 1, nn = EvalError), nn;
}
var an, un;
function Ki() {
  return un || (un = 1, an = RangeError), an;
}
var fn, cn;
function Zi() {
  return cn || (cn = 1, fn = ReferenceError), fn;
}
var ln, pn;
function Xi() {
  return pn || (pn = 1, ln = SyntaxError), ln;
}
var yn, sn;
function Yi() {
  return sn || (sn = 1, yn = URIError), yn;
}
var dn, vn;
function eu() {
  return vn || (vn = 1, dn = Math.abs), dn;
}
var gn, mn;
function tu() {
  return mn || (mn = 1, gn = Math.floor), gn;
}
var hn, bn;
function ru() {
  return bn || (bn = 1, hn = Math.max), hn;
}
var Sn, An;
function nu() {
  return An || (An = 1, Sn = Math.min), Sn;
}
var On, wn;
function ou() {
  return wn || (wn = 1, On = Math.pow), On;
}
var En, Pn;
function au() {
  return Pn || (Pn = 1, En = Math.round), En;
}
var jn, Rn;
function iu() {
  return Rn || (Rn = 1, jn = Number.isNaN || function(t) {
    return t !== t;
  }), jn;
}
var It, xn;
function uu() {
  if (xn)
    return It;
  xn = 1;
  var t = /* @__PURE__ */ iu();
  return It = function(e) {
    return t(e) || e === 0 ? e : e < 0 ? -1 : 1;
  }, It;
}
var Fn, In;
function fu() {
  return In || (In = 1, Fn = Object.getOwnPropertyDescriptor), Fn;
}
var _t, _n;
function Ro() {
  if (_n)
    return _t;
  _n = 1;
  var t = /* @__PURE__ */ fu();
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return _t = t, _t;
}
var Nt, Nn;
function cu() {
  if (Nn)
    return Nt;
  Nn = 1;
  var t = Object.defineProperty || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return Nt = t, Nt;
}
var Tn, Mn;
function lu() {
  return Mn || (Mn = 1, Tn = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, e = Symbol("test"), r = Object(e);
    if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var n = 42;
    t[e] = n;
    for (var a in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var o = Object.getOwnPropertySymbols(t);
    if (o.length !== 1 || o[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var f = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, e)
      );
      if (f.value !== n || f.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Tn;
}
var Tt, kn;
function pu() {
  if (kn)
    return Tt;
  kn = 1;
  var t = typeof Symbol < "u" && Symbol, e = lu();
  return Tt = function() {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, Tt;
}
var $n, Cn;
function xo() {
  return Cn || (Cn = 1, $n = typeof Reflect < "u" && Reflect.getPrototypeOf || null), $n;
}
var Mt, Dn;
function Fo() {
  if (Dn)
    return Mt;
  Dn = 1;
  var t = /* @__PURE__ */ jo();
  return Mt = t.getPrototypeOf || null, Mt;
}
var kt, Bn;
function yu() {
  if (Bn)
    return kt;
  Bn = 1;
  var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, r = Math.max, n = "[object Function]", a = function(i, l) {
    for (var p = [], d = 0; d < i.length; d += 1)
      p[d] = i[d];
    for (var b = 0; b < l.length; b += 1)
      p[b + i.length] = l[b];
    return p;
  }, o = function(i, l) {
    for (var p = [], d = l, b = 0; d < i.length; d += 1, b += 1)
      p[b] = i[d];
    return p;
  }, f = function(i, l) {
    for (var p = "", d = 0; d < i.length; d += 1)
      p += i[d], d + 1 < i.length && (p += l);
    return p;
  };
  return kt = function(i) {
    var l = this;
    if (typeof l != "function" || e.apply(l) !== n)
      throw new TypeError(t + l);
    for (var p = o(arguments, 1), d, b = function() {
      if (this instanceof d) {
        var v = l.apply(
          this,
          a(p, arguments)
        );
        return Object(v) === v ? v : this;
      }
      return l.apply(
        i,
        a(p, arguments)
      );
    }, c = r(0, l.length - p.length), h = [], A = 0; A < c; A++)
      h[A] = "$" + A;
    if (d = Function("binder", "return function (" + f(h, ",") + "){ return binder.apply(this,arguments); }")(b), l.prototype) {
      var y = function() {
      };
      y.prototype = l.prototype, d.prototype = new y(), y.prototype = null;
    }
    return d;
  }, kt;
}
var $t, Un;
function ut() {
  if (Un)
    return $t;
  Un = 1;
  var t = yu();
  return $t = Function.prototype.bind || t, $t;
}
var Wn, Ln;
function vr() {
  return Ln || (Ln = 1, Wn = Function.prototype.call), Wn;
}
var Gn, Hn;
function Io() {
  return Hn || (Hn = 1, Gn = Function.prototype.apply), Gn;
}
var qn, zn;
function su() {
  return zn || (zn = 1, qn = typeof Reflect < "u" && Reflect && Reflect.apply), qn;
}
var Ct, Vn;
function du() {
  if (Vn)
    return Ct;
  Vn = 1;
  var t = ut(), e = Io(), r = vr(), n = su();
  return Ct = n || t.call(r, e), Ct;
}
var Dt, Jn;
function _o() {
  if (Jn)
    return Dt;
  Jn = 1;
  var t = ut(), e = /* @__PURE__ */ We(), r = vr(), n = du();
  return Dt = function(a) {
    if (a.length < 1 || typeof a[0] != "function")
      throw new e("a function is required");
    return n(t, r, a);
  }, Dt;
}
var Bt, Qn;
function vu() {
  if (Qn)
    return Bt;
  Qn = 1;
  var t = _o(), e = /* @__PURE__ */ Ro(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (f) {
    if (!f || typeof f != "object" || !("code" in f) || f.code !== "ERR_PROTO_ACCESS")
      throw f;
  }
  var n = !!r && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, o = a.getPrototypeOf;
  return Bt = n && typeof n.get == "function" ? t([n.get]) : typeof o == "function" ? (
    /** @type {import('./get')} */
    function(f) {
      return o(f == null ? f : a(f));
    }
  ) : !1, Bt;
}
var Ut, Kn;
function gu() {
  if (Kn)
    return Ut;
  Kn = 1;
  var t = xo(), e = Fo(), r = /* @__PURE__ */ vu();
  return Ut = t ? function(n) {
    return t(n);
  } : e ? function(n) {
    if (!n || typeof n != "object" && typeof n != "function")
      throw new TypeError("getProto: not an object");
    return e(n);
  } : r ? function(n) {
    return r(n);
  } : null, Ut;
}
var Wt, Zn;
function mu() {
  if (Zn)
    return Wt;
  Zn = 1;
  var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, r = ut();
  return Wt = r.call(t, e), Wt;
}
var Lt, Xn;
function gr() {
  if (Xn)
    return Lt;
  Xn = 1;
  var t, e = /* @__PURE__ */ jo(), r = /* @__PURE__ */ Ji(), n = /* @__PURE__ */ Qi(), a = /* @__PURE__ */ Ki(), o = /* @__PURE__ */ Zi(), f = /* @__PURE__ */ Xi(), i = /* @__PURE__ */ We(), l = /* @__PURE__ */ Yi(), p = /* @__PURE__ */ eu(), d = /* @__PURE__ */ tu(), b = /* @__PURE__ */ ru(), c = /* @__PURE__ */ nu(), h = /* @__PURE__ */ ou(), A = /* @__PURE__ */ au(), y = /* @__PURE__ */ uu(), v = Function, g = function(U) {
    try {
      return v('"use strict"; return (' + U + ").constructor;")();
    } catch {
    }
  }, m = /* @__PURE__ */ Ro(), S = /* @__PURE__ */ cu(), w = function() {
    throw new i();
  }, E = m ? function() {
    try {
      return arguments.callee, w;
    } catch {
      try {
        return m(arguments, "callee").get;
      } catch {
        return w;
      }
    }
  }() : w, P = pu()(), O = gu(), j = Fo(), T = xo(), W = Io(), B = vr(), I = {}, C = typeof Uint8Array > "u" || !O ? t : O(Uint8Array), k = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
    "%ArrayIteratorPrototype%": P && O ? O([][Symbol.iterator]()) : t,
    "%AsyncFromSyncIteratorPrototype%": t,
    "%AsyncFunction%": I,
    "%AsyncGenerator%": I,
    "%AsyncGeneratorFunction%": I,
    "%AsyncIteratorPrototype%": I,
    "%Atomics%": typeof Atomics > "u" ? t : Atomics,
    "%BigInt%": typeof BigInt > "u" ? t : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? t : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
    "%Function%": v,
    "%GeneratorFunction%": I,
    "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": P && O ? O(O([][Symbol.iterator]())) : t,
    "%JSON%": typeof JSON == "object" ? JSON : t,
    "%Map%": typeof Map > "u" ? t : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !P || !O ? t : O((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": m,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? t : Promise,
    "%Proxy%": typeof Proxy > "u" ? t : Proxy,
    "%RangeError%": a,
    "%ReferenceError%": o,
    "%Reflect%": typeof Reflect > "u" ? t : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? t : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !P || !O ? t : O((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": P && O ? O(""[Symbol.iterator]()) : t,
    "%Symbol%": P ? Symbol : t,
    "%SyntaxError%": f,
    "%ThrowTypeError%": E,
    "%TypedArray%": C,
    "%TypeError%": i,
    "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet,
    "%Function.prototype.call%": B,
    "%Function.prototype.apply%": W,
    "%Object.defineProperty%": S,
    "%Object.getPrototypeOf%": j,
    "%Math.abs%": p,
    "%Math.floor%": d,
    "%Math.max%": b,
    "%Math.min%": c,
    "%Math.pow%": h,
    "%Math.round%": A,
    "%Math.sign%": y,
    "%Reflect.getPrototypeOf%": T
  };
  if (O)
    try {
      null.error;
    } catch (U) {
      var M = O(O(U));
      k["%Error.prototype%"] = M;
    }
  var x = function U(L) {
    var _;
    if (L === "%AsyncFunction%")
      _ = g("async function () {}");
    else if (L === "%GeneratorFunction%")
      _ = g("function* () {}");
    else if (L === "%AsyncGeneratorFunction%")
      _ = g("async function* () {}");
    else if (L === "%AsyncGenerator%") {
      var q = U("%AsyncGeneratorFunction%");
      q && (_ = q.prototype);
    } else if (L === "%AsyncIteratorPrototype%") {
      var z = U("%AsyncGenerator%");
      z && O && (_ = O(z.prototype));
    }
    return k[L] = _, _;
  }, ae = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, Z = ut(), te = /* @__PURE__ */ mu(), he = Z.call(B, Array.prototype.concat), je = Z.call(W, Array.prototype.splice), fe = Z.call(B, String.prototype.replace), Y = Z.call(B, String.prototype.slice), be = Z.call(B, RegExp.prototype.exec), Se = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ce = /\\(\\)?/g, re = function(U) {
    var L = Y(U, 0, 1), _ = Y(U, -1);
    if (L === "%" && _ !== "%")
      throw new f("invalid intrinsic syntax, expected closing `%`");
    if (_ === "%" && L !== "%")
      throw new f("invalid intrinsic syntax, expected opening `%`");
    var q = [];
    return fe(U, Se, function(z, pe, V, K) {
      q[q.length] = V ? fe(K, ce, "$1") : pe || z;
    }), q;
  }, Ae = function(U, L) {
    var _ = U, q;
    if (te(ae, _) && (q = ae[_], _ = "%" + q[0] + "%"), te(k, _)) {
      var z = k[_];
      if (z === I && (z = x(_)), typeof z > "u" && !L)
        throw new i("intrinsic " + U + " exists, but is not available. Please file an issue!");
      return {
        alias: q,
        name: _,
        value: z
      };
    }
    throw new f("intrinsic " + U + " does not exist!");
  };
  return Lt = function(U, L) {
    if (typeof U != "string" || U.length === 0)
      throw new i("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof L != "boolean")
      throw new i('"allowMissing" argument must be a boolean');
    if (be(/^%?[^%]*%?$/, U) === null)
      throw new f("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var _ = re(U), q = _.length > 0 ? _[0] : "", z = Ae("%" + q + "%", L), pe = z.name, V = z.value, K = !1, ee = z.alias;
    ee && (q = ee[0], je(_, he([0, 1], ee)));
    for (var Re = 1, ye = !0; Re < _.length; Re += 1) {
      var ne = _[Re], xe = Y(ne, 0, 1), Fe = Y(ne, -1);
      if ((xe === '"' || xe === "'" || xe === "`" || Fe === '"' || Fe === "'" || Fe === "`") && xe !== Fe)
        throw new f("property names with quotes must have matching quotes");
      if ((ne === "constructor" || !ye) && (K = !0), q += "." + ne, pe = "%" + q + "%", te(k, pe))
        V = k[pe];
      else if (V != null) {
        if (!(ne in V)) {
          if (!L)
            throw new i("base intrinsic for " + U + " exists, but the property is not available.");
          return;
        }
        if (m && Re + 1 >= _.length) {
          var Ie = m(V, ne);
          ye = !!Ie, ye && "get" in Ie && !("originalValue" in Ie.get) ? V = Ie.get : V = V[ne];
        } else
          ye = te(V, ne), V = V[ne];
        ye && !K && (k[pe] = V);
      }
    }
    return V;
  }, Lt;
}
var Gt, Yn;
function No() {
  if (Yn)
    return Gt;
  Yn = 1;
  var t = /* @__PURE__ */ gr(), e = _o(), r = e([t("%String.prototype.indexOf%")]);
  return Gt = function(n, a) {
    var o = (
      /** @type {Parameters<typeof callBindBasic>[0][0]} */
      t(n, !!a)
    );
    return typeof o == "function" && r(n, ".prototype.") > -1 ? e([o]) : o;
  }, Gt;
}
var Ht, eo;
function To() {
  if (eo)
    return Ht;
  eo = 1;
  var t = /* @__PURE__ */ gr(), e = /* @__PURE__ */ No(), r = /* @__PURE__ */ it(), n = /* @__PURE__ */ We(), a = t("%Map%", !0), o = e("Map.prototype.get", !0), f = e("Map.prototype.set", !0), i = e("Map.prototype.has", !0), l = e("Map.prototype.delete", !0), p = e("Map.prototype.size", !0);
  return Ht = !!a && /** @type {Exclude<import('.'), false>} */
  function() {
    var d, b = {
      assert: function(c) {
        if (!b.has(c))
          throw new n("Side channel does not contain " + r(c));
      },
      delete: function(c) {
        if (d) {
          var h = l(d, c);
          return p(d) === 0 && (d = void 0), h;
        }
        return !1;
      },
      get: function(c) {
        if (d)
          return o(d, c);
      },
      has: function(c) {
        return d ? i(d, c) : !1;
      },
      set: function(c, h) {
        d || (d = new a()), f(d, c, h);
      }
    };
    return b;
  }, Ht;
}
var qt, to;
function hu() {
  if (to)
    return qt;
  to = 1;
  var t = /* @__PURE__ */ gr(), e = /* @__PURE__ */ No(), r = /* @__PURE__ */ it(), n = To(), a = /* @__PURE__ */ We(), o = t("%WeakMap%", !0), f = e("WeakMap.prototype.get", !0), i = e("WeakMap.prototype.set", !0), l = e("WeakMap.prototype.has", !0), p = e("WeakMap.prototype.delete", !0);
  return qt = o ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var d, b, c = {
        assert: function(h) {
          if (!c.has(h))
            throw new a("Side channel does not contain " + r(h));
        },
        delete: function(h) {
          if (o && h && (typeof h == "object" || typeof h == "function")) {
            if (d)
              return p(d, h);
          } else if (n && b)
            return b.delete(h);
          return !1;
        },
        get: function(h) {
          return o && h && (typeof h == "object" || typeof h == "function") && d ? f(d, h) : b && b.get(h);
        },
        has: function(h) {
          return o && h && (typeof h == "object" || typeof h == "function") && d ? l(d, h) : !!b && b.has(h);
        },
        set: function(h, A) {
          o && h && (typeof h == "object" || typeof h == "function") ? (d || (d = new o()), i(d, h, A)) : n && (b || (b = n()), b.set(h, A));
        }
      };
      return c;
    }
  ) : n, qt;
}
var zt, ro;
function bu() {
  if (ro)
    return zt;
  ro = 1;
  var t = /* @__PURE__ */ We(), e = /* @__PURE__ */ it(), r = Vi(), n = To(), a = hu(), o = a || n || r;
  return zt = function() {
    var f, i = {
      assert: function(l) {
        if (!i.has(l))
          throw new t("Side channel does not contain " + e(l));
      },
      delete: function(l) {
        return !!f && f.delete(l);
      },
      get: function(l) {
        return f && f.get(l);
      },
      has: function(l) {
        return !!f && f.has(l);
      },
      set: function(l, p) {
        f || (f = o()), f.set(l, p);
      }
    };
    return i;
  }, zt;
}
var Vt, no;
function mr() {
  if (no)
    return Vt;
  no = 1;
  var t = String.prototype.replace, e = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Vt = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return t.call(n, e, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, Vt;
}
var Jt, oo;
function Mo() {
  if (oo)
    return Jt;
  oo = 1;
  var t = mr(), e = Object.prototype.hasOwnProperty, r = Array.isArray, n = function() {
    for (var y = [], v = 0; v < 256; ++v)
      y.push("%" + ((v < 16 ? "0" : "") + v.toString(16)).toUpperCase());
    return y;
  }(), a = function(y) {
    for (; y.length > 1; ) {
      var v = y.pop(), g = v.obj[v.prop];
      if (r(g)) {
        for (var m = [], S = 0; S < g.length; ++S)
          typeof g[S] < "u" && m.push(g[S]);
        v.obj[v.prop] = m;
      }
    }
  }, o = function(y, v) {
    for (var g = v && v.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, m = 0; m < y.length; ++m)
      typeof y[m] < "u" && (g[m] = y[m]);
    return g;
  }, f = function y(v, g, m) {
    if (!g)
      return v;
    if (typeof g != "object") {
      if (r(v))
        v.push(g);
      else if (v && typeof v == "object")
        (m && (m.plainObjects || m.allowPrototypes) || !e.call(Object.prototype, g)) && (v[g] = !0);
      else
        return [v, g];
      return v;
    }
    if (!v || typeof v != "object")
      return [v].concat(g);
    var S = v;
    return r(v) && !r(g) && (S = o(v, m)), r(v) && r(g) ? (g.forEach(function(w, E) {
      if (e.call(v, E)) {
        var P = v[E];
        P && typeof P == "object" && w && typeof w == "object" ? v[E] = y(P, w, m) : v.push(w);
      } else
        v[E] = w;
    }), v) : Object.keys(g).reduce(function(w, E) {
      var P = g[E];
      return e.call(w, E) ? w[E] = y(w[E], P, m) : w[E] = P, w;
    }, S);
  }, i = function(y, v) {
    return Object.keys(v).reduce(function(g, m) {
      return g[m] = v[m], g;
    }, y);
  }, l = function(y, v, g) {
    var m = y.replace(/\+/g, " ");
    if (g === "iso-8859-1")
      return m.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(m);
    } catch {
      return m;
    }
  }, p = function(y, v, g, m, S) {
    if (y.length === 0)
      return y;
    var w = y;
    if (typeof y == "symbol" ? w = Symbol.prototype.toString.call(y) : typeof y != "string" && (w = String(y)), g === "iso-8859-1")
      return escape(w).replace(/%u[0-9a-f]{4}/gi, function(j) {
        return "%26%23" + parseInt(j.slice(2), 16) + "%3B";
      });
    for (var E = "", P = 0; P < w.length; ++P) {
      var O = w.charCodeAt(P);
      if (O === 45 || O === 46 || O === 95 || O === 126 || O >= 48 && O <= 57 || O >= 65 && O <= 90 || O >= 97 && O <= 122 || S === t.RFC1738 && (O === 40 || O === 41)) {
        E += w.charAt(P);
        continue;
      }
      if (O < 128) {
        E = E + n[O];
        continue;
      }
      if (O < 2048) {
        E = E + (n[192 | O >> 6] + n[128 | O & 63]);
        continue;
      }
      if (O < 55296 || O >= 57344) {
        E = E + (n[224 | O >> 12] + n[128 | O >> 6 & 63] + n[128 | O & 63]);
        continue;
      }
      P += 1, O = 65536 + ((O & 1023) << 10 | w.charCodeAt(P) & 1023), E += n[240 | O >> 18] + n[128 | O >> 12 & 63] + n[128 | O >> 6 & 63] + n[128 | O & 63];
    }
    return E;
  }, d = function(y) {
    for (var v = [{ obj: { o: y }, prop: "o" }], g = [], m = 0; m < v.length; ++m)
      for (var S = v[m], w = S.obj[S.prop], E = Object.keys(w), P = 0; P < E.length; ++P) {
        var O = E[P], j = w[O];
        typeof j == "object" && j !== null && g.indexOf(j) === -1 && (v.push({ obj: w, prop: O }), g.push(j));
      }
    return a(v), y;
  }, b = function(y) {
    return Object.prototype.toString.call(y) === "[object RegExp]";
  }, c = function(y) {
    return !y || typeof y != "object" ? !1 : !!(y.constructor && y.constructor.isBuffer && y.constructor.isBuffer(y));
  }, h = function(y, v) {
    return [].concat(y, v);
  }, A = function(y, v) {
    if (r(y)) {
      for (var g = [], m = 0; m < y.length; m += 1)
        g.push(v(y[m]));
      return g;
    }
    return v(y);
  };
  return Jt = {
    arrayToObject: o,
    assign: i,
    combine: h,
    compact: d,
    decode: l,
    encode: p,
    isBuffer: c,
    isRegExp: b,
    maybeMap: A,
    merge: f
  }, Jt;
}
var Qt, ao;
function Su() {
  if (ao)
    return Qt;
  ao = 1;
  var t = bu(), e = Mo(), r = mr(), n = Object.prototype.hasOwnProperty, a = {
    brackets: function(y) {
      return y + "[]";
    },
    comma: "comma",
    indices: function(y, v) {
      return y + "[" + v + "]";
    },
    repeat: function(y) {
      return y;
    }
  }, o = Array.isArray, f = Array.prototype.push, i = function(y, v) {
    f.apply(y, o(v) ? v : [v]);
  }, l = Date.prototype.toISOString, p = r.default, d = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: e.encode,
    encodeValuesOnly: !1,
    format: p,
    formatter: r.formatters[p],
    // deprecated
    indices: !1,
    serializeDate: function(y) {
      return l.call(y);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, b = function(y) {
    return typeof y == "string" || typeof y == "number" || typeof y == "boolean" || typeof y == "symbol" || typeof y == "bigint";
  }, c = {}, h = function y(v, g, m, S, w, E, P, O, j, T, W, B, I, C, k, M) {
    for (var x = v, ae = M, Z = 0, te = !1; (ae = ae.get(c)) !== void 0 && !te; ) {
      var he = ae.get(v);
      if (Z += 1, typeof he < "u") {
        if (he === Z)
          throw new RangeError("Cyclic object value");
        te = !0;
      }
      typeof ae.get(c) > "u" && (Z = 0);
    }
    if (typeof O == "function" ? x = O(g, x) : x instanceof Date ? x = W(x) : m === "comma" && o(x) && (x = e.maybeMap(x, function(_) {
      return _ instanceof Date ? W(_) : _;
    })), x === null) {
      if (w)
        return P && !C ? P(g, d.encoder, k, "key", B) : g;
      x = "";
    }
    if (b(x) || e.isBuffer(x)) {
      if (P) {
        var je = C ? g : P(g, d.encoder, k, "key", B);
        return [I(je) + "=" + I(P(x, d.encoder, k, "value", B))];
      }
      return [I(g) + "=" + I(String(x))];
    }
    var fe = [];
    if (typeof x > "u")
      return fe;
    var Y;
    if (m === "comma" && o(x))
      C && P && (x = e.maybeMap(x, P)), Y = [{ value: x.length > 0 ? x.join(",") || null : void 0 }];
    else if (o(O))
      Y = O;
    else {
      var be = Object.keys(x);
      Y = j ? be.sort(j) : be;
    }
    for (var Se = S && o(x) && x.length === 1 ? g + "[]" : g, ce = 0; ce < Y.length; ++ce) {
      var re = Y[ce], Ae = typeof re == "object" && typeof re.value < "u" ? re.value : x[re];
      if (!(E && Ae === null)) {
        var U = o(x) ? typeof m == "function" ? m(Se, re) : Se : Se + (T ? "." + re : "[" + re + "]");
        M.set(v, Z);
        var L = t();
        L.set(c, M), i(fe, y(
          Ae,
          U,
          m,
          S,
          w,
          E,
          m === "comma" && C && o(x) ? null : P,
          O,
          j,
          T,
          W,
          B,
          I,
          C,
          k,
          L
        ));
      }
    }
    return fe;
  }, A = function(y) {
    if (!y)
      return d;
    if (y.encoder !== null && typeof y.encoder < "u" && typeof y.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var v = y.charset || d.charset;
    if (typeof y.charset < "u" && y.charset !== "utf-8" && y.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var g = r.default;
    if (typeof y.format < "u") {
      if (!n.call(r.formatters, y.format))
        throw new TypeError("Unknown format option provided.");
      g = y.format;
    }
    var m = r.formatters[g], S = d.filter;
    return (typeof y.filter == "function" || o(y.filter)) && (S = y.filter), {
      addQueryPrefix: typeof y.addQueryPrefix == "boolean" ? y.addQueryPrefix : d.addQueryPrefix,
      allowDots: typeof y.allowDots > "u" ? d.allowDots : !!y.allowDots,
      charset: v,
      charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : d.charsetSentinel,
      delimiter: typeof y.delimiter > "u" ? d.delimiter : y.delimiter,
      encode: typeof y.encode == "boolean" ? y.encode : d.encode,
      encoder: typeof y.encoder == "function" ? y.encoder : d.encoder,
      encodeValuesOnly: typeof y.encodeValuesOnly == "boolean" ? y.encodeValuesOnly : d.encodeValuesOnly,
      filter: S,
      format: g,
      formatter: m,
      serializeDate: typeof y.serializeDate == "function" ? y.serializeDate : d.serializeDate,
      skipNulls: typeof y.skipNulls == "boolean" ? y.skipNulls : d.skipNulls,
      sort: typeof y.sort == "function" ? y.sort : null,
      strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : d.strictNullHandling
    };
  };
  return Qt = function(y, v) {
    var g = y, m = A(v), S, w;
    typeof m.filter == "function" ? (w = m.filter, g = w("", g)) : o(m.filter) && (w = m.filter, S = w);
    var E = [];
    if (typeof g != "object" || g === null)
      return "";
    var P;
    v && v.arrayFormat in a ? P = v.arrayFormat : v && "indices" in v ? P = v.indices ? "indices" : "repeat" : P = "indices";
    var O = a[P];
    if (v && "commaRoundTrip" in v && typeof v.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var j = O === "comma" && v && v.commaRoundTrip;
    S || (S = Object.keys(g)), m.sort && S.sort(m.sort);
    for (var T = t(), W = 0; W < S.length; ++W) {
      var B = S[W];
      m.skipNulls && g[B] === null || i(E, h(
        g[B],
        B,
        O,
        j,
        m.strictNullHandling,
        m.skipNulls,
        m.encode ? m.encoder : null,
        m.filter,
        m.sort,
        m.allowDots,
        m.serializeDate,
        m.format,
        m.formatter,
        m.encodeValuesOnly,
        m.charset,
        T
      ));
    }
    var I = E.join(m.delimiter), C = m.addQueryPrefix === !0 ? "?" : "";
    return m.charsetSentinel && (m.charset === "iso-8859-1" ? C += "utf8=%26%2310003%3B&" : C += "utf8=%E2%9C%93&"), I.length > 0 ? C + I : "";
  }, Qt;
}
var Kt, io;
function Au() {
  if (io)
    return Kt;
  io = 1;
  var t = Mo(), e = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: t.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
  }, a = function(c) {
    return c.replace(/&#(\d+);/g, function(h, A) {
      return String.fromCharCode(parseInt(A, 10));
    });
  }, o = function(c, h) {
    return c && typeof c == "string" && h.comma && c.indexOf(",") > -1 ? c.split(",") : c;
  }, f = "utf8=%26%2310003%3B", i = "utf8=%E2%9C%93", l = function(c, h) {
    var A = {}, y = h.ignoreQueryPrefix ? c.replace(/^\?/, "") : c, v = h.parameterLimit === 1 / 0 ? void 0 : h.parameterLimit, g = y.split(h.delimiter, v), m = -1, S, w = h.charset;
    if (h.charsetSentinel)
      for (S = 0; S < g.length; ++S)
        g[S].indexOf("utf8=") === 0 && (g[S] === i ? w = "utf-8" : g[S] === f && (w = "iso-8859-1"), m = S, S = g.length);
    for (S = 0; S < g.length; ++S)
      if (S !== m) {
        var E = g[S], P = E.indexOf("]="), O = P === -1 ? E.indexOf("=") : P + 1, j, T;
        O === -1 ? (j = h.decoder(E, n.decoder, w, "key"), T = h.strictNullHandling ? null : "") : (j = h.decoder(E.slice(0, O), n.decoder, w, "key"), T = t.maybeMap(
          o(E.slice(O + 1), h),
          function(W) {
            return h.decoder(W, n.decoder, w, "value");
          }
        )), T && h.interpretNumericEntities && w === "iso-8859-1" && (T = a(T)), E.indexOf("[]=") > -1 && (T = r(T) ? [T] : T), e.call(A, j) ? A[j] = t.combine(A[j], T) : A[j] = T;
      }
    return A;
  }, p = function(c, h, A, y) {
    for (var v = y ? h : o(h, A), g = c.length - 1; g >= 0; --g) {
      var m, S = c[g];
      if (S === "[]" && A.parseArrays)
        m = [].concat(v);
      else {
        m = A.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var w = S.charAt(0) === "[" && S.charAt(S.length - 1) === "]" ? S.slice(1, -1) : S, E = parseInt(w, 10);
        !A.parseArrays && w === "" ? m = { 0: v } : !isNaN(E) && S !== w && String(E) === w && E >= 0 && A.parseArrays && E <= A.arrayLimit ? (m = [], m[E] = v) : w !== "__proto__" && (m[w] = v);
      }
      v = m;
    }
    return v;
  }, d = function(c, h, A, y) {
    if (c) {
      var v = A.allowDots ? c.replace(/\.([^.[]+)/g, "[$1]") : c, g = /(\[[^[\]]*])/, m = /(\[[^[\]]*])/g, S = A.depth > 0 && g.exec(v), w = S ? v.slice(0, S.index) : v, E = [];
      if (w) {
        if (!A.plainObjects && e.call(Object.prototype, w) && !A.allowPrototypes)
          return;
        E.push(w);
      }
      for (var P = 0; A.depth > 0 && (S = m.exec(v)) !== null && P < A.depth; ) {
        if (P += 1, !A.plainObjects && e.call(Object.prototype, S[1].slice(1, -1)) && !A.allowPrototypes)
          return;
        E.push(S[1]);
      }
      return S && E.push("[" + v.slice(S.index) + "]"), p(E, h, A, y);
    }
  }, b = function(c) {
    if (!c)
      return n;
    if (c.decoder !== null && c.decoder !== void 0 && typeof c.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof c.charset < "u" && c.charset !== "utf-8" && c.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var h = typeof c.charset > "u" ? n.charset : c.charset;
    return {
      allowDots: typeof c.allowDots > "u" ? n.allowDots : !!c.allowDots,
      allowPrototypes: typeof c.allowPrototypes == "boolean" ? c.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof c.allowSparse == "boolean" ? c.allowSparse : n.allowSparse,
      arrayLimit: typeof c.arrayLimit == "number" ? c.arrayLimit : n.arrayLimit,
      charset: h,
      charsetSentinel: typeof c.charsetSentinel == "boolean" ? c.charsetSentinel : n.charsetSentinel,
      comma: typeof c.comma == "boolean" ? c.comma : n.comma,
      decoder: typeof c.decoder == "function" ? c.decoder : n.decoder,
      delimiter: typeof c.delimiter == "string" || t.isRegExp(c.delimiter) ? c.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof c.depth == "number" || c.depth === !1 ? +c.depth : n.depth,
      ignoreQueryPrefix: c.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof c.interpretNumericEntities == "boolean" ? c.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof c.parameterLimit == "number" ? c.parameterLimit : n.parameterLimit,
      parseArrays: c.parseArrays !== !1,
      plainObjects: typeof c.plainObjects == "boolean" ? c.plainObjects : n.plainObjects,
      strictNullHandling: typeof c.strictNullHandling == "boolean" ? c.strictNullHandling : n.strictNullHandling
    };
  };
  return Kt = function(c, h) {
    var A = b(h);
    if (c === "" || c === null || typeof c > "u")
      return A.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var y = typeof c == "string" ? l(c, A) : c, v = A.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, g = Object.keys(y), m = 0; m < g.length; ++m) {
      var S = g[m], w = d(S, y[S], A, typeof c == "string");
      v = t.merge(v, w, A);
    }
    return A.allowSparse === !0 ? v : t.compact(v);
  }, Kt;
}
var Zt, uo;
function Ou() {
  if (uo)
    return Zt;
  uo = 1;
  var t = Su(), e = Au(), r = mr();
  return Zt = {
    formats: r,
    parse: e,
    stringify: t
  }, Zt;
}
var wu = Ou();
const Eu = { Accept: "application/json, text/plain, */*" };
let Xt, Yt;
const er = [];
class ft {
  /**
   * update headers of all providers
   * @param headers request's additional headers
   * @return void
   */
  static setHeaders(e) {
    for (const r of er)
      r.setHeaders(e);
  }
  /**
   * update request's params object of all providers
   * @param requestParameters request's params object
   * @return void
   */
  static setRequestParams(e) {
    for (const r of er)
      r.setRequestParams(e);
  }
  /**
   * set callback for every response of all providers
   * @param function_ callback
   * @return void
   */
  static setResponseCallback(e) {
    Xt = e;
  }
  /**
   * set callback for every response of all providers that has errors
   * @param function_ callback
   * @return void
   */
  static setResponseErrorCallback(e) {
    Yt = e;
  }
  /**
   * create new RestClient instance - 'provider'
   * @param path provider rest point
   * @param headers headers object
   * @param restPath endpoint for all requests
   * @param requestParameters request's params object
   */
  constructor(e, r = {}, n = "", a = {}) {
    this.path = e, this.restPath = n, this.headers = { ...Eu, ...r }, this.requestParams = a, er.push(this);
  }
  /**
   * update headers of current provider
   * @param headers updating headers
   * @return void
   */
  setHeaders(e) {
    this.headers = { ...this.headers, ...e };
  }
  /**
   * update requests params of current provider
   * @param requestParameters request's params object
   * @return void
   */
  setRequestParams(e) {
    this.requestParams = { ...this.requestParams, ...e };
  }
  /**
   * GET-request
   * @param path request's path, relative to provider's path
   * @param query request's query params
   * @param headers request's additional headers
   * @param requestParameters request's params object
   * @param stringifyOptions Stringify Options
   * @return Promise<R>
   */
  get(e, r = {}, n = null, a = {}, o) {
    const f = Object.keys(r), i = e + (f.length > 0 ? `?${wu.stringify(r, { indices: !1, ...o })}` : "");
    return this.request("GET", i, null, n, a);
  }
  /**
   * POST-request
   * @param path request's path, relative to provider's path
   * @param body request's body
   * @param headers request's additional headers
   * @param requestParameters request's params object
   * @return Promise<R>
   */
  post(e, r, n = null, a = {}) {
    return this.request("POST", e, r, n, a);
  }
  /**
   * PUT-request
   * @param path request's path, relative to provider's path
   * @param body request's body
   * @param headers request's additional headers
   * @param requestParameters request's params object
   * @return Promise<R>
   */
  put(e, r, n = null, a = {}) {
    return this.request("PUT", e, r, n, a);
  }
  /**
   * PATCH-request
   * @param path request's path, relative to provider's path
   * @param body request's body
   * @param headers request's additional headers
   * @param requestParameters request's params object
   * @return Promise<R>
   */
  patch(e, r, n = null, a = {}) {
    return this.request("PATCH", e, r, n, a);
  }
  /**
   * DELETE-request
   * @param path request's path, relative to provider's path
   * @param headers request's additional headers
   * @param body request's body
   * @param requestParameters request's params object
   * @return Promise<R>
   */
  delete(e, r = null, n, a = {}) {
    return this.request("DELETE", e, n, r, a);
  }
  upload(e, r, n, a) {
    const o = new XMLHttpRequest();
    return o.upload.addEventListener("progress", n, !1), o.addEventListener("load", a, !1), o.open("POST", this.restPath + this.path + e, !0), new Promise((f, i) => {
      o.addEventListener("readystatechange", () => {
        o.readyState === 4 && (o.status >= 200 && o.status < 300 ? f(JSON.parse(o.responseText)) : i(o.responseText));
      }), o.send(r);
    });
  }
  // eslint-disable-next-line sonarjs/cognitive-complexity
  request(e, r, n, a = null, o = {}) {
    const f = r.charAt(0) === "/" ? "" : "/", i = r.charAt(0) === "?" ? "" : f, l = r ? i : "", p = this.restPath + this.path + l + r, d = {
      ...this.requestParams,
      ...o,
      method: e,
      headers: {
        ...this.headers,
        ...this.requestParams.headers,
        ...o.headers,
        ...a
      }
    };
    return n && (d.body = JSON.stringify(n)), d.credentials = "include", fetch(p, d).then((b) => {
      if (typeof Xt == "function" && Xt(b), b.ok) {
        if (b.status === 204)
          return null;
        const c = b.clone();
        return b.json().catch(() => {
          var h;
          return ((h = d.headers) == null ? void 0 : h["Content-Type"]) === "application/json" ? null : c.text();
        });
      }
      return b.json().then((c) => {
        throw typeof c == "object" && (c.response = b), typeof Yt == "function" && Yt(c), c;
      });
    });
  }
}
typeof window < "u" && (window.affstoreDsRestClient = { RestClient: ft });
var hr = /* @__PURE__ */ ((t) => (t.Get = "/", t.GetAffiliate = "/affiliate", t.GetApiTH = "/api/t/h", t.GetApiTrackerAffiliate = "/api/tracker/affiliate", t.PostApiTrackerAffiliateAction = "/api/tracker/affiliate/action", t.GetApiTrackerHit = "/api/tracker/hit", t.GetApiTrackerReferral = "/api/tracker/referral", t.GetApiTrackerRetentionHit = "/api/tracker/retention/hit", t.GetHit = "/hit", t.GetReferral = "/referral", t.GetReg = "/reg", t.GetRetentionHit = "/retention/hit", t))(hr || {});
const Pu = (t, e) => new ft(hr.GetApiTrackerAffiliate, {}, e, {
  mode: "cors",
  referrerPolicy: "no-referrer"
}).get("", t), ju = (t, e) => new ft(hr.PostApiTrackerAffiliateAction, {}, e, {
  mode: "cors",
  referrerPolicy: "no-referrer"
}).post("", t, { "Content-Type": "application/json" }), ko = "/", Ru = 3, xu = (t, e, r = {}) => {
  const n = { ...r, path: r.path || ko }, { expires: a } = n;
  if (typeof a == "number" && a) {
    const f = /* @__PURE__ */ new Date();
    f.setTime(f.getTime() + a * 1e3), n.expires = f.toUTCString();
  }
  const o = encodeURIComponent(e);
  document.cookie = Object.entries(n).reduce((f, [i, l]) => {
    const p = l === !0 ? "" : `=${l}`;
    return `${f}; ${i}${p}`;
  }, `${t}=${o}`);
}, fo = (t) => {
  const e = document.cookie.match(`(^|;) ?${t}=([^;]*)(;|$)`);
  return e ? unescape(e[2]) : null;
}, Fu = {
  afftrack: "aff_track",
  ref_id: "aff_id",
  sourceMarker: "source"
}, Iu = 86400 * 30, _u = -99999999, $o = ["ref_id", "afftrack", "sourceMarker", "source", "keyword"], Co = ["ref_id", "afftrack", "source", "keyword"], Nu = {
  sourceMarker: "source"
}, br = typeof window < "u", Tu = () => {
  const t = br ? window.location.search : "", r = new URLSearchParams(t).entries(), n = {};
  for (const [a, o] of r)
    n[a] = o;
  return n;
}, ke = Tu(), Mu = () => typeof ke != "object" || ke === null ? !1 : ke.ref_id ? typeof ke.ref_id == "string" && /^\d+$/.test(ke.ref_id) : !0, ku = () => $o.reduce((t, e) => {
  const r = ke[e];
  if (r != null) {
    const n = Nu[e] || e;
    t.set(n, r);
  }
  return t;
}, /* @__PURE__ */ new Map()), co = ku(), Uu = (t) => ft.setResponseErrorCallback(t), $u = () => br ? Co.map(
  (t) => fo(t) ? { [`${t}`]: fo(t) } : !1
).filter(Boolean).reduce((t, e) => Object.assign(t, e), {}) : {}, Cu = (t, e = ko) => {
  if (!(co.size <= 0 || !Mu()))
    for (const r of Co) {
      const n = co.get(r);
      xu(r, n || "", {
        domain: t,
        path: e,
        expires: n ? Iu : _u
      });
    }
}, Du = (t, e) => {
  const r = Li.parse(window.location.search, { ignoreQueryPrefix: !0 }), n = $o.reduce(
    (a, o) => {
      const f = r[o];
      if (f === void 0)
        return a;
      const i = Fu[o] || o;
      return { ...a, [i]: f };
    },
    { site_id: t }
  );
  try {
    Pu(n, e);
  } catch (a) {
    console.error(a);
  }
}, Bu = (t) => {
  ju(
    {
      name: Ru
    },
    t
  );
};
br && (window.affiliateFrontendAnalyticsTracker = {
  checkParametersAndSendHit: Du,
  getWrittenCookies: $u,
  sendCabinetOpenedEvent: Bu,
  setWrittenCookies: Cu
});
export {
  Du as checkParametersAndSendHit,
  $u as getWrittenCookies,
  Bu as sendCabinetOpenedEvent,
  Uu as setErrorCallback,
  Cu as setWrittenCookies
};
//# sourceMappingURL=affiliate-frontend-analytics-tracker.js.map
